export const isIntegerOrEmpty = (input: string) =>
  input === '' ? true : /^\d+$/.test(input)
